@if (hasPicture()) {
  <ngx-picture-carousel [images]="images" [config]="config"></ngx-picture-carousel>
} @else {
  <img [src]="appConfig.PLACEHOLDER_CAROUSEL" alt="{{ 'LABEL.NO_ASSET_PICTURE' | translate }}"
    class="default-widget-img"/>
}
